import { render, staticRenderFns } from "./NtdUsersTable.vue?vue&type=template&id=59464290&scoped=true"
import script from "./NtdUsersTable.vue?vue&type=script&lang=ts"
export * from "./NtdUsersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59464290",
  null
  
)

export default component.exports